import React, {type FC} from 'react';
import {type RenderLeafProps} from 'slate-react';

import {LeafNode} from './LeafNode';
import {type TextWithFormatting} from './types';

export const WBSlateLeaf: FC<RenderLeafProps> = props => {
  const typedLeaf = props.leaf as TextWithFormatting;
  return (
    <LeafNode
      data-test="leaf-node-with-formatting"
      {...props}
      leaf={typedLeaf}></LeafNode>
  );
};
